import React, { ReactElement, ReactNode, useContext, useEffect, useMemo } from "react";
import './cryptid.css';
import alien093 from 'url:../../assets/alien093.png';
import { Ad, AdBanner } from "../../components/AdBanner";
import { MusicPlayer } from "../../components/MusicPlayer";
import intro from 'url:../../assets/stop-intro.mp3';
import ufo_on from 'url:../../assets/ufo.png';
import ufo_off from 'url:../../assets/ufo-off.png';
import { Divider } from "../../components/Divider";
import { SiteCounter } from "../../components/SiteCounter";
import { Outlet, useNavigate } from "react-router";
import { StampCollection } from "../../components/StampCollection";
import { StampType } from "../../components/Stamp";
import { Plzen } from "../../components/cursor/plz/Plzen";
import { SlotDrag } from "../../components/cursor/draggables/SlotDrag";
import PlayerProvider from "../../providers/PlayerProvider";
import { SITE_INFO_CRNN } from "../../providers/SitesProvider";

export function CNN0 () {
    const player = useContext(PlayerProvider.context);

    useEffect(() => {
        player.unlockSite(SITE_INFO_CRNN.key);
    }, []);

    const page = useMemo(() => {
        return <div className='page-basic cnn-bg font-treb'>
            <div className='h-box cnn-body-width padding-16'>
                <div className='v-box'>
                    <AdBanner ad={Ad.Gooze} animated={true} />
                    <div className="h-box center-all gap-8">
                        <p className="text-gray-light text-16 font-mono"><i>You are not alone...</i></p>
                        <SiteCounter />
                    </div>
                    <h1 className="text-32 text-red font-treb">CREEPY NOWHERE NEWS</h1>
                    <CryptidNav />
                    <br /> <br />
                    <Outlet />
                </div>
                <SlotDrag>
                    <img src={alien093} width='96px'/>
                </SlotDrag>
                <div className="cnn-sidebar">
                    <CryptidBox header="SITE UPDATES">
                        <p className="text-green text-18">9.22.99</p>
                        <p className="text-white text-18">Fixed text anomalies. Should be normal now.</p>
                    </CryptidBox>
                    <CryptidBox header="SIGNALS">
                        <div className="cnn-audio-box">
                            <MusicPlayer audio={intro}/>
                            <Divider />
                            <div className="cnn-audio-list">
                                <CryptidAudioItem label="Mothfoot" audio="" />
                                <CryptidAudioItem label="Outhound" audio="" />
                                <CryptidAudioItem label="Old Janet" audio="" />
                                <CryptidAudioItem label="Cornhog" audio="" />
                                <CryptidAudioItem label="Disappearances" audio="" />
                                <CryptidAudioItem label="UFOs" audio="" />
                            </div>
                        </div>
                    </CryptidBox>
                    <CryptidBox header="REPORT SIGHTINGS">
                        <div>
                            <button>Click Here!!</button>
                        </div>
                    </CryptidBox>
                    <StampCollection stamps={[
                        StampType.TROK,
                        StampType.WTROK,
                        StampType.Anime,
                        StampType.Cryptid,
                        StampType.Phranks
                    ]} />
                </div>
            </div>
        </div>;
    }, []);

    return page;
}

function CryptidNav () {
    return <div className="h-box gap-8">
        <CryptidNavButton text="HOME" url="/cnn" />
        <CryptidNavButton text="TESTIMONIALS" url="/cnn/testimonials" />
        <CryptidNavButtonX text="FORUMS" url="/cnn/forums/home" />
    </div>
            
}

export function CryptidNavButton (props: {text: string, url:string}) {
    const nav = useNavigate();
    return <div 
        className="cnn-outline width-192 text-white text-18 bg-red padding-4"
        onClick={() => { nav(props.url); }}>
            {props.text}
    </div>
}

export function CryptidNavButtonX (props: {text: string, url:string}) {
    const nav = useNavigate();
    return <Plzen onState={
        <div 
            className="cnn-outline width-192 text-white text-18 bg-red padding-4"
            onClick={() => { nav(props.url); }}>
                {props.text}
        </div>
    } offState={
        <div 
            className="cnn-outline width-192 text-gray-dark text-18 bg-black padding-4">
                {props.text}
        </div>
    }>

    </Plzen>
}

export function CryptidBox(props: {header : string, children : ReactNode}) {
    return <div className='cnn-outline'>
        <h3 className='cnn-box-header text-24 text-white'>{props.header}</h3>
        <div className='cnn-box-body'>{props.children}</div>
    </div>;
}

function CryptidAudioItem (props: {label: string, audio: string}) {
    return <Plzen onState={
        <div className="cnn-audio-item">
            <img src={ufo_on} width='32px' />
            <a className="text-white">{props.label}</a>
        </div>
    } offState={
        <div className="cnn-audio-item">
            <img src={ufo_off} width='32px' />
            <a className="text-gray-dark">{props.label}</a>
        </div>
    } />
}